<template>
    <a class="library_card_a">
        <div class="library_card_img_layout_div">
            <div class="o_image o_image_thumbnail" :data-mimetype="data.mimetype"/>
        </div>
        <div class="library_card_layout_div">
            <p class="library_card_title_p no_margin">{{ data.name }}</p>
            <p class="library_card_chapter_p no_margin">共{{ data.page_count }}页</p>
        </div>
    </a>
</template>
<script type="text/javascript">

    export default {
        props: {
            data: {
                type: Object,
                require: true
            },
        },
        components: {},
        methods: {}
    }
</script>
<style type="text/css" scoped>
    .library_card_a {
        display: flex;
        border: 1px solid #eee;
        box-shadow: 0 1px 2px 0 #d2d2d2;
        padding: 11px 13px;
        margin-bottom: 32px;
    }

    .library_card_a:hover {
        box-shadow: 0 2px 8px 0 #d2d2d2;
    }

    .library_card_img_layout_div {
        padding: 5px 10px 5px 0;
    }

    .library_card_img {
        width: 54px;
        height: 54px;
        border-radius: 50%;
    }

    .library_card_layout_div {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .library_card_title_p {
        font-size: 16px;
        color: #565656;
        max-height: 45px;
        overflow: hidden;
        word-break: break-word;
        text-overflow: ellipsis;
    }

    .library_card_chapter_p {
        font-size: 14px;
        color: #666;
    }

    .no_margin {
        margin: 0;
    }

</style>
